import React from 'react';
import ProjectManagementDashboard from '@/components/ProjectManagement';

/**
 * ProjectManagement Page
 * Thin wrapper — all logic and layout lives in the component tree.
 * This keeps the page file consistent with the ERP pattern (see Admin.jsx, Dashboard.jsx).
 */
export default function ProjectManagement() {
    return <ProjectManagementDashboard />;
}
